import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ProfileVisitDetailModel} from '../views/models/profile-visit-detail.model';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {ProfileVisitModel} from '../views/models/profile-visit.model';

@Injectable({
  providedIn: 'root'
})
export class ProfileVisitDetailService {

  visitDetail_change$ = new BehaviorSubject<ProfileVisitDetailModel[]>([]);
  visit_change$ = new BehaviorSubject<ProfileVisitModel[]>([]);
  pending_profile_visit_change$ = new BehaviorSubject<ProfileVisitModel[]>([]);

  constructor(private httpClient: HttpClient) {
  }


  getVisitDetailbyID(profile_id: number) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/profile_visit_details/' + profile_id).subscribe(
      (visitDetail: ProfileVisitDetailModel[]) => {
        this.visitDetail_change$.next(visitDetail);
      }
    );
  }

  getVisitbyID(profile_id: number) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/profile_visit/' + profile_id).subscribe(
      (visit: ProfileVisitModel[]) => {
        this.visit_change$.next(visit);
      }
    );
  }

  getPendingVisit() {
    this.httpClient.get(environment.baseURL + '/v2/api/pending_profile_visit').subscribe(
      (visit: ProfileVisitModel[]) => {
        console.log(visit);
        this.pending_profile_visit_change$.next(visit);
      }
    );
  }

}
